export const youtubeSizeHelper = (e) => {
  const { height } = e.target.getSize();
  e.target.setSize(height, (height / 16) * 9);
};
